// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file trade/v1/purchase_order.proto (package trade.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Base, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { PurchaseOrderLineItem } from "./purchase_order_line_item_pb.js";
import { file_trade_v1_purchase_order_line_item } from "./purchase_order_line_item_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file trade/v1/purchase_order.proto.
 */
export const file_trade_v1_purchase_order: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_google_protobuf_struct, file_types, file_trade_v1_purchase_order_line_item]);

/**
 * PurchaseOrder message definition
 *
 * @generated from message trade.v1.PurchaseOrder
 */
export type PurchaseOrder = Message<"trade.v1.PurchaseOrder"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string document_number = 2;
   */
  documentNumber: string;

  /**
   * @generated from field: trade.v1.PurchaseOrderStatus status = 3;
   */
  status: PurchaseOrderStatus;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 4;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 5;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: types.ID account_id = 6;
   */
  accountId?: ID;

  /**
   * @generated from field: types.ID account_contact_id = 7;
   */
  accountContactId?: ID;

  /**
   * @generated from field: types.ID account_representative_id = 8;
   */
  accountRepresentativeId?: ID;

  /**
   * @generated from field: string counterparty_number = 9;
   */
  counterpartyNumber: string;

  /**
   * @generated from field: types.ID account_address_id = 10;
   */
  accountAddressId?: ID;

  /**
   * @generated from field: types.ID facility_id = 11;
   */
  facilityId?: ID;

  /**
   * @generated from field: string payment_currency = 12;
   */
  paymentCurrency: string;

  /**
   * @generated from field: string freight_term = 13;
   */
  freightTerm: string;

  /**
   * @generated from field: string payment_term = 14;
   */
  paymentTerm: string;

  /**
   * @generated from field: string notes = 15;
   */
  notes: string;

  /**
   * @generated from field: string completion_notes = 16;
   */
  completionNotes: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 17;
   */
  customAttributes: { [key: string]: Value };

  /**
   * @generated from field: types.Base base = 18;
   */
  base?: Base;

  /**
   * @generated from field: repeated trade.v1.PurchaseOrderLineItem line_items = 19;
   */
  lineItems: PurchaseOrderLineItem[];
};

/**
 * Describes the message trade.v1.PurchaseOrder.
 * Use `create(PurchaseOrderSchema)` to create a new message.
 */
export const PurchaseOrderSchema: GenMessage<PurchaseOrder> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 0);

/**
 * PurchaseOrderStatusCounts - custom type
 *
 * @generated from message trade.v1.PurchaseOrderStatusCounts
 */
export type PurchaseOrderStatusCounts = Message<"trade.v1.PurchaseOrderStatusCounts"> & {
  /**
   * @generated from field: int32 draft = 1;
   */
  draft: number;

  /**
   * @generated from field: int32 voided = 2;
   */
  voided: number;

  /**
   * @generated from field: int32 open = 3;
   */
  open: number;

  /**
   * @generated from field: int32 closed = 4;
   */
  closed: number;

  /**
   * @generated from field: int32 total = 5;
   */
  total: number;
};

/**
 * Describes the message trade.v1.PurchaseOrderStatusCounts.
 * Use `create(PurchaseOrderStatusCountsSchema)` to create a new message.
 */
export const PurchaseOrderStatusCountsSchema: GenMessage<PurchaseOrderStatusCounts> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 1);

/**
 * PurchaseOrderFileCreatePayload - custom payload type
 *
 * @generated from message trade.v1.PurchaseOrderFileCreatePayload
 */
export type PurchaseOrderFileCreatePayload = Message<"trade.v1.PurchaseOrderFileCreatePayload"> & {
  /**
   * @generated from field: string file = 1;
   */
  file: string;

  /**
   * @generated from field: string upload_url = 2;
   */
  uploadUrl: string;
};

/**
 * Describes the message trade.v1.PurchaseOrderFileCreatePayload.
 * Use `create(PurchaseOrderFileCreatePayloadSchema)` to create a new message.
 */
export const PurchaseOrderFileCreatePayloadSchema: GenMessage<PurchaseOrderFileCreatePayload> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 2);

/**
 * PurchaseOrderFileInput - custom input type
 *
 * @generated from message trade.v1.PurchaseOrderFileInput
 */
export type PurchaseOrderFileInput = Message<"trade.v1.PurchaseOrderFileInput"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: int32 file_size = 2;
   */
  fileSize: number;

  /**
   * @generated from field: string mime_type = 3;
   */
  mimeType: string;

  /**
   * @generated from field: bool public = 4;
   */
  public: boolean;
};

/**
 * Describes the message trade.v1.PurchaseOrderFileInput.
 * Use `create(PurchaseOrderFileInputSchema)` to create a new message.
 */
export const PurchaseOrderFileInputSchema: GenMessage<PurchaseOrderFileInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 3);

/**
 * Request/Response messages for PurchaseOrder queries
 *
 * @generated from message trade.v1.GetPurchaseOrderRequest
 */
export type GetPurchaseOrderRequest = Message<"trade.v1.GetPurchaseOrderRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message trade.v1.GetPurchaseOrderRequest.
 * Use `create(GetPurchaseOrderRequestSchema)` to create a new message.
 */
export const GetPurchaseOrderRequestSchema: GenMessage<GetPurchaseOrderRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 4);

/**
 * @generated from message trade.v1.GetPurchaseOrderResponse
 */
export type GetPurchaseOrderResponse = Message<"trade.v1.GetPurchaseOrderResponse"> & {
  /**
   * @generated from field: trade.v1.PurchaseOrder purchase_order = 1;
   */
  purchaseOrder?: PurchaseOrder;
};

/**
 * Describes the message trade.v1.GetPurchaseOrderResponse.
 * Use `create(GetPurchaseOrderResponseSchema)` to create a new message.
 */
export const GetPurchaseOrderResponseSchema: GenMessage<GetPurchaseOrderResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 5);

/**
 * @generated from message trade.v1.ListPurchaseOrdersRequest
 */
export type ListPurchaseOrdersRequest = Message<"trade.v1.ListPurchaseOrdersRequest"> & {
  /**
   * @generated from field: trade.v1.ListPurchaseOrdersFilter filter = 1;
   */
  filter?: ListPurchaseOrdersFilter;

  /**
   * @generated from field: repeated trade.v1.PurchaseOrderSortOption sorting = 2;
   */
  sorting: PurchaseOrderSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message trade.v1.ListPurchaseOrdersRequest.
 * Use `create(ListPurchaseOrdersRequestSchema)` to create a new message.
 */
export const ListPurchaseOrdersRequestSchema: GenMessage<ListPurchaseOrdersRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 6);

/**
 * @generated from message trade.v1.ListPurchaseOrdersFilter
 */
export type ListPurchaseOrdersFilter = Message<"trade.v1.ListPurchaseOrdersFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: google.protobuf.StringValue document_number = 2;
   */
  documentNumber?: string;

  /**
   * @generated from field: trade.v1.PurchaseOrderStatus status = 3;
   */
  status: PurchaseOrderStatus;

  /**
   * @generated from field: google.protobuf.StringValue counterparty_number = 4;
   */
  counterpartyNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue search_term = 5;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 6;
   */
  organizationId?: ID;
};

/**
 * Describes the message trade.v1.ListPurchaseOrdersFilter.
 * Use `create(ListPurchaseOrdersFilterSchema)` to create a new message.
 */
export const ListPurchaseOrdersFilterSchema: GenMessage<ListPurchaseOrdersFilter> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 7);

/**
 * @generated from message trade.v1.ListPurchaseOrdersResponse
 */
export type ListPurchaseOrdersResponse = Message<"trade.v1.ListPurchaseOrdersResponse"> & {
  /**
   * @generated from field: repeated trade.v1.PurchaseOrder purchase_orders = 1;
   */
  purchaseOrders: PurchaseOrder[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message trade.v1.ListPurchaseOrdersResponse.
 * Use `create(ListPurchaseOrdersResponseSchema)` to create a new message.
 */
export const ListPurchaseOrdersResponseSchema: GenMessage<ListPurchaseOrdersResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 8);

/**
 * Command messages
 *
 * @generated from message trade.v1.CreatePurchaseOrderRequest
 */
export type CreatePurchaseOrderRequest = Message<"trade.v1.CreatePurchaseOrderRequest"> & {
  /**
   * @generated from field: trade.v1.PurchaseOrderInput input = 1;
   */
  input?: PurchaseOrderInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message trade.v1.CreatePurchaseOrderRequest.
 * Use `create(CreatePurchaseOrderRequestSchema)` to create a new message.
 */
export const CreatePurchaseOrderRequestSchema: GenMessage<CreatePurchaseOrderRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 9);

/**
 * @generated from message trade.v1.CreatePurchaseOrderResponse
 */
export type CreatePurchaseOrderResponse = Message<"trade.v1.CreatePurchaseOrderResponse"> & {
  /**
   * @generated from field: trade.v1.PurchaseOrder purchase_order = 1;
   */
  purchaseOrder?: PurchaseOrder;
};

/**
 * Describes the message trade.v1.CreatePurchaseOrderResponse.
 * Use `create(CreatePurchaseOrderResponseSchema)` to create a new message.
 */
export const CreatePurchaseOrderResponseSchema: GenMessage<CreatePurchaseOrderResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 10);

/**
 * @generated from message trade.v1.UpdatePurchaseOrderRequest
 */
export type UpdatePurchaseOrderRequest = Message<"trade.v1.UpdatePurchaseOrderRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: trade.v1.PurchaseOrderUpdateInput input = 2;
   */
  input?: PurchaseOrderUpdateInput;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message trade.v1.UpdatePurchaseOrderRequest.
 * Use `create(UpdatePurchaseOrderRequestSchema)` to create a new message.
 */
export const UpdatePurchaseOrderRequestSchema: GenMessage<UpdatePurchaseOrderRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 11);

/**
 * @generated from message trade.v1.UpdatePurchaseOrderResponse
 */
export type UpdatePurchaseOrderResponse = Message<"trade.v1.UpdatePurchaseOrderResponse"> & {
  /**
   * @generated from field: trade.v1.PurchaseOrder purchase_order = 1;
   */
  purchaseOrder?: PurchaseOrder;
};

/**
 * Describes the message trade.v1.UpdatePurchaseOrderResponse.
 * Use `create(UpdatePurchaseOrderResponseSchema)` to create a new message.
 */
export const UpdatePurchaseOrderResponseSchema: GenMessage<UpdatePurchaseOrderResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 12);

/**
 * @generated from message trade.v1.DeletePurchaseOrderRequest
 */
export type DeletePurchaseOrderRequest = Message<"trade.v1.DeletePurchaseOrderRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message trade.v1.DeletePurchaseOrderRequest.
 * Use `create(DeletePurchaseOrderRequestSchema)` to create a new message.
 */
export const DeletePurchaseOrderRequestSchema: GenMessage<DeletePurchaseOrderRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 13);

/**
 * Input messages
 *
 * @generated from message trade.v1.PurchaseOrderInput
 */
export type PurchaseOrderInput = Message<"trade.v1.PurchaseOrderInput"> & {
  /**
   * @generated from field: string document_number = 1;
   */
  documentNumber: string;

  /**
   * @generated from field: trade.v1.PurchaseOrderStatus status = 2;
   */
  status: PurchaseOrderStatus;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 3;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 4;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: types.ID account_id = 5;
   */
  accountId?: ID;

  /**
   * @generated from field: types.ID account_contact_id = 6;
   */
  accountContactId?: ID;

  /**
   * @generated from field: types.ID account_representative_id = 7;
   */
  accountRepresentativeId?: ID;

  /**
   * @generated from field: string counterparty_number = 8;
   */
  counterpartyNumber: string;

  /**
   * @generated from field: types.ID account_address_id = 9;
   */
  accountAddressId?: ID;

  /**
   * @generated from field: types.ID facility_id = 10;
   */
  facilityId?: ID;

  /**
   * @generated from field: string payment_currency = 11;
   */
  paymentCurrency: string;

  /**
   * @generated from field: string freight_term = 12;
   */
  freightTerm: string;

  /**
   * @generated from field: string payment_term = 13;
   */
  paymentTerm: string;

  /**
   * @generated from field: string notes = 14;
   */
  notes: string;

  /**
   * @generated from field: string completion_notes = 15;
   */
  completionNotes: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 16;
   */
  customAttributes: { [key: string]: Value };
};

/**
 * Describes the message trade.v1.PurchaseOrderInput.
 * Use `create(PurchaseOrderInputSchema)` to create a new message.
 */
export const PurchaseOrderInputSchema: GenMessage<PurchaseOrderInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 14);

/**
 * @generated from message trade.v1.PurchaseOrderUpdateInput
 */
export type PurchaseOrderUpdateInput = Message<"trade.v1.PurchaseOrderUpdateInput"> & {
  /**
   * @generated from field: google.protobuf.StringValue document_number = 1;
   */
  documentNumber?: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 2;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 3;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: types.ID account_id = 4;
   */
  accountId?: ID;

  /**
   * @generated from field: types.ID account_contact_id = 5;
   */
  accountContactId?: ID;

  /**
   * @generated from field: types.ID account_representative_id = 6;
   */
  accountRepresentativeId?: ID;

  /**
   * @generated from field: google.protobuf.StringValue counterparty_number = 7;
   */
  counterpartyNumber?: string;

  /**
   * @generated from field: types.ID account_address_id = 8;
   */
  accountAddressId?: ID;

  /**
   * @generated from field: types.ID facility_id = 9;
   */
  facilityId?: ID;

  /**
   * @generated from field: google.protobuf.StringValue payment_currency = 10;
   */
  paymentCurrency?: string;

  /**
   * @generated from field: google.protobuf.StringValue freight_term = 11;
   */
  freightTerm?: string;

  /**
   * @generated from field: google.protobuf.StringValue payment_term = 12;
   */
  paymentTerm?: string;

  /**
   * @generated from field: google.protobuf.StringValue notes = 13;
   */
  notes?: string;

  /**
   * @generated from field: google.protobuf.StringValue completion_notes = 14;
   */
  completionNotes?: string;

  /**
   * @generated from field: google.protobuf.StringValue custom_attributes = 15;
   */
  customAttributes?: string;
};

/**
 * Describes the message trade.v1.PurchaseOrderUpdateInput.
 * Use `create(PurchaseOrderUpdateInputSchema)` to create a new message.
 */
export const PurchaseOrderUpdateInputSchema: GenMessage<PurchaseOrderUpdateInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 15);

/**
 * GetPurchaseOrdersRequest - custom query request
 *
 * @generated from message trade.v1.GetPurchaseOrdersRequest
 */
export type GetPurchaseOrdersRequest = Message<"trade.v1.GetPurchaseOrdersRequest"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: bool include_line_items = 2;
   */
  includeLineItems: boolean;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message trade.v1.GetPurchaseOrdersRequest.
 * Use `create(GetPurchaseOrdersRequestSchema)` to create a new message.
 */
export const GetPurchaseOrdersRequestSchema: GenMessage<GetPurchaseOrdersRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 16);

/**
 * GetPurchaseOrdersResponse - custom query response
 *
 * @generated from message trade.v1.GetPurchaseOrdersResponse
 */
export type GetPurchaseOrdersResponse = Message<"trade.v1.GetPurchaseOrdersResponse"> & {
  /**
   * @generated from field: repeated trade.v1.PurchaseOrder result = 1;
   */
  result: PurchaseOrder[];
};

/**
 * Describes the message trade.v1.GetPurchaseOrdersResponse.
 * Use `create(GetPurchaseOrdersResponseSchema)` to create a new message.
 */
export const GetPurchaseOrdersResponseSchema: GenMessage<GetPurchaseOrdersResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 17);

/**
 * CountPurchaseOrdersByStatusRequest - custom query request
 *
 * @generated from message trade.v1.CountPurchaseOrdersByStatusRequest
 */
export type CountPurchaseOrdersByStatusRequest = Message<"trade.v1.CountPurchaseOrdersByStatusRequest"> & {
  /**
   * @generated from field: repeated types.ID facility_ids = 1;
   */
  facilityIds: ID[];

  /**
   * @generated from field: repeated types.ID account_ids = 2;
   */
  accountIds: ID[];

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message trade.v1.CountPurchaseOrdersByStatusRequest.
 * Use `create(CountPurchaseOrdersByStatusRequestSchema)` to create a new message.
 */
export const CountPurchaseOrdersByStatusRequestSchema: GenMessage<CountPurchaseOrdersByStatusRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 18);

/**
 * CountPurchaseOrdersByStatusResponse - custom query response
 *
 * @generated from message trade.v1.CountPurchaseOrdersByStatusResponse
 */
export type CountPurchaseOrdersByStatusResponse = Message<"trade.v1.CountPurchaseOrdersByStatusResponse"> & {
  /**
   * @generated from field: trade.v1.PurchaseOrderStatusCounts result = 1;
   */
  result?: PurchaseOrderStatusCounts;
};

/**
 * Describes the message trade.v1.CountPurchaseOrdersByStatusResponse.
 * Use `create(CountPurchaseOrdersByStatusResponseSchema)` to create a new message.
 */
export const CountPurchaseOrdersByStatusResponseSchema: GenMessage<CountPurchaseOrdersByStatusResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 19);

/**
 * CheckPurchaseOrderSearchPermissionsRequest - custom query request
 *
 * @generated from message trade.v1.CheckPurchaseOrderSearchPermissionsRequest
 */
export type CheckPurchaseOrderSearchPermissionsRequest = Message<"trade.v1.CheckPurchaseOrderSearchPermissionsRequest"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message trade.v1.CheckPurchaseOrderSearchPermissionsRequest.
 * Use `create(CheckPurchaseOrderSearchPermissionsRequestSchema)` to create a new message.
 */
export const CheckPurchaseOrderSearchPermissionsRequestSchema: GenMessage<CheckPurchaseOrderSearchPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 20);

/**
 * CheckPurchaseOrderSearchPermissionsResponse - custom query response
 *
 * @generated from message trade.v1.CheckPurchaseOrderSearchPermissionsResponse
 */
export type CheckPurchaseOrderSearchPermissionsResponse = Message<"trade.v1.CheckPurchaseOrderSearchPermissionsResponse"> & {
  /**
   * @generated from field: repeated string permitted_ids = 1;
   */
  permittedIds: string[];
};

/**
 * Describes the message trade.v1.CheckPurchaseOrderSearchPermissionsResponse.
 * Use `create(CheckPurchaseOrderSearchPermissionsResponseSchema)` to create a new message.
 */
export const CheckPurchaseOrderSearchPermissionsResponseSchema: GenMessage<CheckPurchaseOrderSearchPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 21);

/**
 * VoidPurchaseOrderRequest - custom mutation request
 *
 * @generated from message trade.v1.VoidPurchaseOrderRequest
 */
export type VoidPurchaseOrderRequest = Message<"trade.v1.VoidPurchaseOrderRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message trade.v1.VoidPurchaseOrderRequest.
 * Use `create(VoidPurchaseOrderRequestSchema)` to create a new message.
 */
export const VoidPurchaseOrderRequestSchema: GenMessage<VoidPurchaseOrderRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 22);

/**
 * VoidPurchaseOrderResponse - custom mutation response
 *
 * @generated from message trade.v1.VoidPurchaseOrderResponse
 */
export type VoidPurchaseOrderResponse = Message<"trade.v1.VoidPurchaseOrderResponse"> & {
  /**
   * @generated from field: trade.v1.PurchaseOrder result = 1;
   */
  result?: PurchaseOrder;
};

/**
 * Describes the message trade.v1.VoidPurchaseOrderResponse.
 * Use `create(VoidPurchaseOrderResponseSchema)` to create a new message.
 */
export const VoidPurchaseOrderResponseSchema: GenMessage<VoidPurchaseOrderResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 23);

/**
 * ReopenPurchaseOrderRequest - custom mutation request
 *
 * @generated from message trade.v1.ReopenPurchaseOrderRequest
 */
export type ReopenPurchaseOrderRequest = Message<"trade.v1.ReopenPurchaseOrderRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message trade.v1.ReopenPurchaseOrderRequest.
 * Use `create(ReopenPurchaseOrderRequestSchema)` to create a new message.
 */
export const ReopenPurchaseOrderRequestSchema: GenMessage<ReopenPurchaseOrderRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 24);

/**
 * ReopenPurchaseOrderResponse - custom mutation response
 *
 * @generated from message trade.v1.ReopenPurchaseOrderResponse
 */
export type ReopenPurchaseOrderResponse = Message<"trade.v1.ReopenPurchaseOrderResponse"> & {
  /**
   * @generated from field: trade.v1.PurchaseOrder result = 1;
   */
  result?: PurchaseOrder;
};

/**
 * Describes the message trade.v1.ReopenPurchaseOrderResponse.
 * Use `create(ReopenPurchaseOrderResponseSchema)` to create a new message.
 */
export const ReopenPurchaseOrderResponseSchema: GenMessage<ReopenPurchaseOrderResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 25);

/**
 * ClosePurchaseOrderRequest - custom mutation request
 *
 * @generated from message trade.v1.ClosePurchaseOrderRequest
 */
export type ClosePurchaseOrderRequest = Message<"trade.v1.ClosePurchaseOrderRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string notes = 2;
   */
  notes: string;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message trade.v1.ClosePurchaseOrderRequest.
 * Use `create(ClosePurchaseOrderRequestSchema)` to create a new message.
 */
export const ClosePurchaseOrderRequestSchema: GenMessage<ClosePurchaseOrderRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 26);

/**
 * ClosePurchaseOrderResponse - custom mutation response
 *
 * @generated from message trade.v1.ClosePurchaseOrderResponse
 */
export type ClosePurchaseOrderResponse = Message<"trade.v1.ClosePurchaseOrderResponse"> & {
  /**
   * @generated from field: trade.v1.PurchaseOrder result = 1;
   */
  result?: PurchaseOrder;
};

/**
 * Describes the message trade.v1.ClosePurchaseOrderResponse.
 * Use `create(ClosePurchaseOrderResponseSchema)` to create a new message.
 */
export const ClosePurchaseOrderResponseSchema: GenMessage<ClosePurchaseOrderResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order, 27);

/**
 * PurchaseOrderStatus enum
 *
 * @generated from enum trade.v1.PurchaseOrderStatus
 */
export enum PurchaseOrderStatus {
  /**
   * @generated from enum value: PURCHASE_ORDER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PURCHASE_ORDER_STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: PURCHASE_ORDER_STATUS_VOIDED = 2;
   */
  VOIDED = 2,

  /**
   * @generated from enum value: PURCHASE_ORDER_STATUS_OPEN = 3;
   */
  OPEN = 3,

  /**
   * @generated from enum value: PURCHASE_ORDER_STATUS_CLOSED = 4;
   */
  CLOSED = 4,
}

/**
 * Describes the enum trade.v1.PurchaseOrderStatus.
 */
export const PurchaseOrderStatusSchema: GenEnum<PurchaseOrderStatus> = /*@__PURE__*/
  enumDesc(file_trade_v1_purchase_order, 0);

/**
 * @generated from enum trade.v1.PurchaseOrderSortOption
 */
export enum PurchaseOrderSortOption {
  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_DOCUMENT_NUMBER_ASC = 1;
   */
  DOCUMENT_NUMBER_ASC = 1,

  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_DOCUMENT_NUMBER_DESC = 2;
   */
  DOCUMENT_NUMBER_DESC = 2,

  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_STATUS_ASC = 3;
   */
  STATUS_ASC = 3,

  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_STATUS_DESC = 4;
   */
  STATUS_DESC = 4,

  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_START_DATE_ASC = 5;
   */
  START_DATE_ASC = 5,

  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_START_DATE_DESC = 6;
   */
  START_DATE_DESC = 6,

  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_END_DATE_ASC = 7;
   */
  END_DATE_ASC = 7,

  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_END_DATE_DESC = 8;
   */
  END_DATE_DESC = 8,

  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_ACCOUNT_ID_ASC = 9;
   */
  ACCOUNT_ID_ASC = 9,

  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_ACCOUNT_ID_DESC = 10;
   */
  ACCOUNT_ID_DESC = 10,

  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_PAYMENT_CURRENCY_ASC = 11;
   */
  PAYMENT_CURRENCY_ASC = 11,

  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_PAYMENT_CURRENCY_DESC = 12;
   */
  PAYMENT_CURRENCY_DESC = 12,

  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_CREATED_AT_ASC = 13;
   */
  CREATED_AT_ASC = 13,

  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_CREATED_AT_DESC = 14;
   */
  CREATED_AT_DESC = 14,

  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_UPDATED_AT_ASC = 15;
   */
  UPDATED_AT_ASC = 15,

  /**
   * @generated from enum value: PURCHASE_ORDER_SORT_OPTION_UPDATED_AT_DESC = 16;
   */
  UPDATED_AT_DESC = 16,
}

/**
 * Describes the enum trade.v1.PurchaseOrderSortOption.
 */
export const PurchaseOrderSortOptionSchema: GenEnum<PurchaseOrderSortOption> = /*@__PURE__*/
  enumDesc(file_trade_v1_purchase_order, 1);

/**
 * Services
 *
 * @generated from service trade.v1.PurchaseOrderQueriesService
 */
export const PurchaseOrderQueriesService: GenService<{
  /**
   * @generated from rpc trade.v1.PurchaseOrderQueriesService.GetPurchaseOrder
   */
  getPurchaseOrder: {
    methodKind: "unary";
    input: typeof GetPurchaseOrderRequestSchema;
    output: typeof GetPurchaseOrderResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.PurchaseOrderQueriesService.ListPurchaseOrders
   */
  listPurchaseOrders: {
    methodKind: "unary";
    input: typeof ListPurchaseOrdersRequestSchema;
    output: typeof ListPurchaseOrdersResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.PurchaseOrderQueriesService.GetPurchaseOrders
   */
  getPurchaseOrders: {
    methodKind: "unary";
    input: typeof GetPurchaseOrdersRequestSchema;
    output: typeof GetPurchaseOrdersResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.PurchaseOrderQueriesService.CountPurchaseOrdersByStatus
   */
  countPurchaseOrdersByStatus: {
    methodKind: "unary";
    input: typeof CountPurchaseOrdersByStatusRequestSchema;
    output: typeof CountPurchaseOrdersByStatusResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.PurchaseOrderQueriesService.CheckSearchPermissions
   */
  checkSearchPermissions: {
    methodKind: "unary";
    input: typeof CheckPurchaseOrderSearchPermissionsRequestSchema;
    output: typeof CheckPurchaseOrderSearchPermissionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_trade_v1_purchase_order, 0);

/**
 * @generated from service trade.v1.PurchaseOrderCommandsService
 */
export const PurchaseOrderCommandsService: GenService<{
  /**
   * @generated from rpc trade.v1.PurchaseOrderCommandsService.CreatePurchaseOrder
   */
  createPurchaseOrder: {
    methodKind: "unary";
    input: typeof CreatePurchaseOrderRequestSchema;
    output: typeof CreatePurchaseOrderResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.PurchaseOrderCommandsService.UpdatePurchaseOrder
   */
  updatePurchaseOrder: {
    methodKind: "unary";
    input: typeof UpdatePurchaseOrderRequestSchema;
    output: typeof UpdatePurchaseOrderResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.PurchaseOrderCommandsService.DeletePurchaseOrder
   */
  deletePurchaseOrder: {
    methodKind: "unary";
    input: typeof DeletePurchaseOrderRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc trade.v1.PurchaseOrderCommandsService.VoidPurchaseOrder
   */
  voidPurchaseOrder: {
    methodKind: "unary";
    input: typeof VoidPurchaseOrderRequestSchema;
    output: typeof VoidPurchaseOrderResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.PurchaseOrderCommandsService.ReopenPurchaseOrder
   */
  reopenPurchaseOrder: {
    methodKind: "unary";
    input: typeof ReopenPurchaseOrderRequestSchema;
    output: typeof ReopenPurchaseOrderResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.PurchaseOrderCommandsService.ClosePurchaseOrder
   */
  closePurchaseOrder: {
    methodKind: "unary";
    input: typeof ClosePurchaseOrderRequestSchema;
    output: typeof ClosePurchaseOrderResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_trade_v1_purchase_order, 1);

